import { displayValue, orderedLeafColumns, toDate } from "./columnDefs";

/** Excel guarda a data em UTC: usa a meia-noite UTC do dia local exibido na tela. */
const toLocalDay = (value) => {
    const date = toDate(value);
    return date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) : null;
};

const exportCell = (config, value, row) =>
    config.type === "date" ? toLocalDay(value) : displayValue(config, value, row);

/** Linhas filtradas e ordenadas (todas as páginas), com as colunas ocultas. */
export const buildExportMatrix = (table) => {
    const columns = orderedLeafColumns(table).filter((column) => {
        const config = column.columnDef.meta?.config ?? {};
        return config.exportable !== false && Boolean(config.header);
    });
    return {
        headers: columns.map((column) => column.columnDef.meta.config.header),
        widths: columns.map((column) => column.getSize()),
        rows: table.getPrePaginationRowModel().rows.map((row) =>
            columns.map((column) => exportCell(column.columnDef.meta.config, row.getValue(column.id), row.original))
        ),
    };
};

const downloadBlob = (blob, fileName) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const exportTableToExcel = async (table, fileName) => {
    const module = await import("exceljs");
    const ExcelJS = module.default ?? module;
    const { headers, rows, widths } = buildExportMatrix(table);
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Dados");
    sheet.columns = headers.map((header, index) => ({ header, key: `c${index}`, width: Math.max(10, Math.round(widths[index] / 7)) }));
    rows.forEach((values) => sheet.addRow(values));
    sheet.getRow(1).font = { bold: true };
    headers.forEach((_, index) => {
        if (rows.some((values) => values[index] instanceof Date)) sheet.getColumn(index + 1).numFmt = "dd/mm/yyyy";
    });
    const buffer = await workbook.xlsx.writeBuffer();
    downloadBlob(
        new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        `${fileName}.xlsx`
    );
};
